<template>
  <div class="container" :style="{'right': newRight, 'top': newTop}">
    <div class="item cancel-collection cursor_p flex-c color_40" @click.stop="cancel">移除储备</div>
    <div class="item set-group cursor_p flex-c color_40" @click.stop="setGroup">设置分组</div>
  </div>
</template>

<script>
export default {
  name: "CancelCollection",
  props:{
    top:{
      type: String,
      default: '0px'
    },
    right:{
      type: String,
      default: '0px'
    },
    isManage:{
      type: Boolean,
      default: false
    },
    // 当前选中的resumelist
    currentResume:{
      type: Object,
      default: () => ({})
    },
    routePageName: {
      type: String,
      default: ""
    }
  },
  computed: {
    // 计算特殊页面的位置
    newTop() {
      if (this.routePageName === 'talentCollection') {
        return '88px'
      }
      return this.top
    },
    newRight() {
      if (['talentCollection', 'talentRefuseDelivery'].includes(this.routePageName)) {
        return '35px'
      }
      return this.right
    }
  },
  methods: {
    cancel() {
      this.$emit('close')
      this.$emit('cancel')
    },
    setGroup() {
      this.$emit('close')
      this.$emit('setGroup')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  cursor: default;
  height: 88px;
  width: 96px;
  border-radius: 6px 6px 6px 6px;
  position: absolute;
  background: #fff;
  top: 44px;
  right: 0;
  z-index: 5;
  box-sizing: border-box;
  padding-bottom: 44px;
  overflow: hidden;
  box-shadow: 0 0 15px 0 rgba(149, 156, 182, 0.15);
  .item {
    width: 100%;
    height: 44px;
    &:hover {
      font-weight: 500;
    }
  }
}
</style>
